import { NavLink } from 'react-router-dom';

// Shared sub-tab bar for the "Výuka" admin section so every question/lesson
// console renders the same tabs with correct active state.
const cls = ({ isActive }: { isActive: boolean }) => "subTab" + (isActive ? " active" : "");

export default function VyukaTabs() {
    return (
        <div className="subTabs">
            <NavLink to="/admin/vyuka" end className={cls}>Lekce</NavLink>
            <NavLink to="/admin/otazky" end className={cls}>Banka otázek</NavLink>
            <NavLink to="/admin/otazky/import" className={cls}>Import</NavLink>
            <NavLink to="/admin/otazky/kontrola" className={cls}>Kontrola</NavLink>
        </div>
    );
}
